import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth-store";
import { useUserStore } from "@/stores/user-store";

const navTabs = [
  { path: "/admin/orders", label: "주문관리", icon: "ri-file-list-3-line" },
  { path: "/admin/styles", label: "스타일관리", icon: "ri-palette-line" },
  { path: "/admin/portfolios", label: "포트폴리오", icon: "ri-image-2-line" },
];

export default function AdminHeader() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = () => {
    useAuthStore.getState().clearTokens();
    useUserStore.getState().clearAdmin();
    navigate("/admin/login");
  };

  return (
    <header className="bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-6">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-orange-500 rounded-lg flex items-center justify-center">
              <i className="ri-admin-line text-xl text-white"></i>
            </div>
            <div>
              <h1 className="text-lg font-bold text-slate-900">봄날 AI 어드민</h1>
              <p className="text-xs text-slate-500">관리 시스템</p>
            </div>
          </div>

          {/* Navigation Tabs */}
          <nav className="flex items-center gap-1 ml-4">
            {navTabs.map((tab) => {
              const isActive = pathname.startsWith(tab.path);
              return (
                <button
                  key={tab.path}
                  onClick={() => navigate(tab.path)}
                  className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                    isActive
                      ? "bg-amber-50 text-amber-700"
                      : "text-slate-600 hover:text-slate-900 hover:bg-slate-50"
                  }`}
                >
                  <i className={`${tab.icon} text-base`}></i>
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>

        <button
          onClick={handleLogout}
          className="flex items-center gap-2 px-4 py-2 text-sm text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors whitespace-nowrap"
        >
          <i className="ri-logout-box-line text-base"></i>
          로그아웃
        </button>
      </div>
    </header>
  );
}
